<script>
  import {
    Input,
    Textarea,
    Button,
    SortableList,
    Card,
    FileSelect
  } from "../components/ui";

  import Icon from "svelte-awesome";
  import { faPen } from "@fortawesome/free-solid-svg-icons";
  import ListItemEdit from "./ListItem_Edit.svelte";

  export let model;
  export let hasEditMode;
  export let hasFileSelect = false;
  let className = "";
  export { className as class };
</script>

<Card class={className}>
  <div class="relative">
    {#if model.editMode}
      <Input bind:model={model.name} class="mt-2 mb-2" />
    {:else}
      <h2 class="text-xl">{model.name}</h2>
    {/if}
    <!-- {#if model.editMode}
        <Textarea bind:model={model.description} class="mt-2 mb-2"/>
        {:else} -->
    <p class="text-sm text-gray-700">{model.description}</p>
    {#if hasFileSelect}
      <FileSelect
        bind:model={model.image}
        class="sm:col-span-6"
        label="Image" />
    {/if}
    <!-- {/if} -->
    {#if model.editMode}
      <Button
        on:submit={() => {
          model.editMode = false;
        }}
        primary={true}>
        Save
      </Button>
    {/if}
    {#if !model.editMode && hasEditMode}
      <button
        type="button"
        on:click={() => {
          model.editMode = true;
        }}
        class="absolute top-0 right-0">
        <Icon data={faPen} scale={1} class="text-main" />
      </button>
    {/if}
  </div>
  <SortableList bind:list={model.items} comp={ListItemEdit} />
</Card>
